<div class="bmc-connectors-sap" *ngIf="selectedConnector">
    <div class="bmc-connectors-custom__name">
        <bzg-icon [nameIcon]="'icon-bizagi'" [size]="29" [fill]="'none'"></bzg-icon>
        <label class="bmc-connectors-custom__name__text">{{displayName}}</label>
    </div>
    <div class="bmc-connectors-custom__display-name">
        <label class="bmc-connectors-custom__display-name__title">{{'CONNECTORS.NAME'| translate}}</label>
        <label>{{name}}</label>
    </div>

    <bzg-button-primary class="bz-space--inline-m" (click)="TestConnection()">
            {{ 'CONNECTORS.TEST_CONNECTION' | translate }}
        </bzg-button-primary>

        
    <div class="bmc-connectors-fields">
        <div class="bmc-connectors-fields__field bmc-connectors-fields--field-header">
            <div class="bmc-connectors-fields-property">
                <label class="bmc-connectors-fields-property__header">{{'CONNECTORS.PROPERTY' | translate}}</label>
            </div>
            <div class="bmc-connectors-fields-value">
                <label class="bmc-connectors-fields-value__header">{{'CONNECTORS.VALUE' | translate}}</label>
            </div>
        </div>
        <div class="bmc-connectors-fields__field" *ngFor="let property of properties | keyvalue">
            <div class="bmc-connectors-fields-property">
                <label class="bmc-connectors-fields__field">{{'CONNECTORS.' + (property.key | uppercase) | translate}}</label>
            </div>
            <div class="bmc-connectors-fields-value">
                <bzg-input type='password' *ngIf="property.value.type === 'password'" [(ngModel)]="selectedConnector.properties[property.key]"
                           [required]="property.value.required"
                    placeholder="{{ 'GLOBAL.EMPTY' | translate }}">
                </bzg-input>
                <bzg-input type='text' *ngIf="property.value.type === 'text'" [(ngModel)]="selectedConnector.properties[property.key]"
                           [required]="property.value.required"
                    placeholder="{{ 'GLOBAL.EMPTY' | translate }}">
                </bzg-input>
              <bzg-input  name="{{property.key}}number" *ngIf="property.value.type === 'number'" [type]="'number'" [min]="property.value.min" [max]="property.value.max"
                          [required]="property.value.required" (keypress)="utilsService.onlyNumbers($event)"
                          [(ngModel)]="selectedConnector.properties[property.key]"  placeholder="{{ 'GLOBAL.EMPTY' | translate }}">
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{'GLOBAL.INVALID_MAX_VALUE' | translate}} {{property.value.max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{property.value.min}}</bzg-min-error>
              </bzg-input>



                <bzg-icon [nameIcon]="'info'" [bzgTooltip]="('CONNECTORS.' + (property.key | uppercase) + '_HELPTEXT') | translate" bzgTooltipPosition="above">
                </bzg-icon>
            </div>
        </div>
    </div>
</div>
